export default __webpack_public_path__ + "arrow-angle-pointing-down.png";